var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: [
        "department-daily-schedule pa-0",
        _vm.compact ? "compact d-inline-block" : "full"
      ],
      attrs: { fluid: "" }
    },
    [
      _vm.compact
        ? [
            _c(
              "v-row",
              {
                staticClass: "column-header px-2",
                attrs: { align: "center", "no-gutters": "" }
              },
              [
                _c(
                  "v-col",
                  {
                    staticClass:
                      "font-weight-medium text-truncate department-name",
                    attrs: { title: _vm.department.name }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.department.name) + "\n      "
                    )
                  ]
                ),
                !_vm.retrievingSchedule && _vm.scheduleStateIndicator
                  ? _c(
                      "v-col",
                      { attrs: { cols: "auto" } },
                      [
                        _c(
                          "v-chip",
                          {
                            class: [
                              "font-weight-medium white--text",
                              _vm.scheduleStateIndicator.stateLabelCssClass
                            ],
                            attrs: { "x-small": "" }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.scheduleStateIndicator.stateLabelKey
                                  )
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.retrievingSchedule &&
                !_vm.readOnly &&
                (_vm.showFinalizeButton || _vm.showFinalizeMessage)
                  ? _c(
                      "v-col",
                      { attrs: { cols: "auto" } },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "", "max-width": "320px" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _vm.showFinalizeButton
                                        ? _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "finalize ml-1",
                                                  attrs: {
                                                    color: "secondary",
                                                    disabled: _vm.finalizing,
                                                    icon: "",
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.finalizeScheduleChanges.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm.finalizing
                                                ? _c("v-progress-circular", {
                                                    attrs: {
                                                      color:
                                                        "primary lighten-2",
                                                      indeterminate: "",
                                                      size: "18",
                                                      width: "2"
                                                    }
                                                  })
                                                : _c(
                                                    "v-icon",
                                                    { attrs: { size: "16" } },
                                                    [
                                                      _vm._v(
                                                        "\n                fas fa-paper-plane\n              "
                                                      )
                                                    ]
                                                  )
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "ml-1 finalized",
                                                  attrs: {
                                                    color: "info",
                                                    size: "14"
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n              fal fa-question-circle\n            "
                                              )
                                            ]
                                          )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2051353251
                            )
                          },
                          [
                            _c("span", { staticClass: "body-2" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.showFinalizeButton
                                      ? _vm.$t("labels.finalize")
                                      : _vm.$t(
                                          "descriptions.dailyScheduleFinalizedHint"
                                        )
                                  ) +
                                  "\n          "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("v-divider")
          ]
        : !_vm.retrievingSchedule
        ? [
            _c(
              "portal",
              { attrs: { to: "daily-schedule-finalize" } },
              [
                !_vm.readOnly
                  ? [
                      _vm.showFinalizeButton
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "finalize mb-1 ml-2",
                              attrs: {
                                color: "secondary",
                                disabled: _vm.finalizing,
                                text: _vm.$vuetify.breakpoint.lgAndUp,
                                icon: _vm.$vuetify.breakpoint.mdAndDown,
                                title: _vm.$t("labels.finalize")
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.finalizeScheduleChanges.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _vm.finalizing
                                ? _c("v-progress-circular", {
                                    attrs: {
                                      color: "primary lighten-2",
                                      indeterminate: "",
                                      size: "22",
                                      width: "2"
                                    }
                                  })
                                : _c("v-icon", { attrs: { size: "20" } }, [
                                    _vm._v(
                                      "\n            fas fa-paper-plane\n          "
                                    )
                                  ]),
                              _vm.$vuetify.breakpoint.lgAndUp
                                ? _c("span", { staticClass: "ml-2" }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("labels.finalize")) +
                                        "\n          "
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm.showFinalizeMessage
                        ? _c(
                            "span",
                            { staticClass: "caption font-weight-medium ml-2" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$vuetify.breakpoint.lgAndDown
                                      ? ""
                                      : _vm.$t(
                                          "descriptions.dailyScheduleFinalized"
                                        )
                                  ) +
                                  "\n          "
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { "max-width": "320px", bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "mt-n1",
                                                    attrs: {
                                                      color: "info",
                                                      size: "14"
                                                    }
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  "\n                fal fa-question-circle\n              "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2041200423
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "descriptions.dailyScheduleFinalizedHint"
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            ),
            _c(
              "portal",
              { attrs: { to: "daily-schedule-state" } },
              [
                _vm.scheduleStateIndicator
                  ? [
                      _c(
                        "v-chip",
                        {
                          class: [
                            "font-weight-medium ml-5 white--text",
                            _vm.scheduleStateIndicator.stateLabelCssClass
                          ],
                          attrs: { small: "" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(_vm.scheduleStateIndicator.stateLabelKey)
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm.readOnly
                        ? _c(
                            "span",
                            {
                              class: [
                                "caption font-weight-medium ml-3 grey--text text--darken-1"
                              ]
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("labels.readOnlyMode")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        : _vm._e(),
      _vm.retrievingSchedule && _vm.showSkeletonLoader
        ? [
            _c(
              "v-container",
              { staticClass: "pa-0", attrs: { fluid: "" } },
              [
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c("v-spacer"),
                    _c(
                      "v-col",
                      { staticClass: "text-center" },
                      [
                        _c("v-btn", {
                          attrs: {
                            disabled: "",
                            elevation: 0,
                            fab: "",
                            small: ""
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { staticClass: "text-center" },
                      [
                        _c("v-btn", {
                          attrs: {
                            disabled: "",
                            elevation: 0,
                            fab: "",
                            small: ""
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { staticClass: "text-center" },
                      [
                        _c("v-btn", {
                          attrs: {
                            disabled: "",
                            elevation: 0,
                            fab: "",
                            small: ""
                          }
                        })
                      ],
                      1
                    ),
                    _c("v-spacer")
                  ],
                  1
                ),
                _c("v-divider"),
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "single-action",
                          attrs: { type: "list-item-avatar" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "single-action",
                          attrs: { type: "list-item-avatar" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "single-action",
                          attrs: { type: "list-item-avatar" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "single-action",
                          attrs: { type: "list-item-avatar" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : !_vm.retrievingSchedule
        ? [
            _c(
              "v-container",
              { staticClass: "pa-0", attrs: { fluid: "" } },
              [
                _c(
                  "v-container",
                  { staticClass: "body-container pa-0", attrs: { fluid: "" } },
                  [
                    !_vm.compact
                      ? _c(
                          "v-row",
                          { attrs: { dense: "", "no-gutters": "" } },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "v-tabs",
                                  {
                                    staticClass: "job-type-tabs",
                                    attrs: {
                                      "mobile-breakpoint": "768",
                                      "show-arrows": "",
                                      "slider-color": "accent",
                                      "slider-size": "3"
                                    },
                                    model: {
                                      value: _vm.selectedJobTypeTab,
                                      callback: function($$v) {
                                        _vm.selectedJobTypeTab = $$v
                                      },
                                      expression: "selectedJobTypeTab"
                                    }
                                  },
                                  _vm._l(_vm.jobTypes, function(
                                    jobTypeGroup,
                                    index
                                  ) {
                                    return _c(
                                      "v-tab",
                                      { key: index },
                                      [
                                        _vm._l(jobTypeGroup, function(
                                          jobType,
                                          jobIndex
                                        ) {
                                          return [
                                            jobIndex > 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    key: jobType.id + "-plus",
                                                    staticClass: "ml-2"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    +\n                  "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                key: jobType.id + "-name",
                                                class:
                                                  jobIndex > 0 ? "ml-2" : ""
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(jobType.name) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                key: jobType.id + "-count",
                                                class: [
                                                  "font-weight-bold job-count ml-2 px-1",
                                                  _vm.ratioCount[jobType.id] &&
                                                  _vm.ratioCount[jobType.id] !==
                                                    _vm.jobTypeCount[jobType.id]
                                                    ? "imbalance"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.jobTypeCount[
                                                          jobType.id
                                                        ]
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              ]
                                            ),
                                            jobType.id !==
                                              _vm.ALL_JOB_TYPES_ID &&
                                            _vm.ratioCount[jobType.id] &&
                                            _vm.ratioCount[jobType.id] !==
                                              _vm.jobTypeCount[jobType.id]
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: jobType.id + "-ratio",
                                                    class: [
                                                      "font-weight-bold job-count ml-2 px-1 ratio"
                                                    ]
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.ratioCount[
                                                              jobType.id
                                                            ]
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("v-data-table", {
                      staticClass: "categories",
                      attrs: {
                        dense: "",
                        "fixed-header": "",
                        "group-by": "category",
                        headers: _vm.headers,
                        "header-props": { sortIcon: "fa fa-arrow-up" },
                        height: _vm.tableHeight + "px",
                        "hide-default-footer": "",
                        items: _vm.filteredItems,
                        "items-per-page": _vm.filteredItems.length,
                        "mobile-breakpoint": "",
                        "no-data-text": _vm.$t("descriptions.noShifts"),
                        "sort-by": _vm.sort.columns,
                        "sort-desc": _vm.sort.order
                      },
                      on: {
                        "update:sort-by": _vm.setSortBy,
                        "update:sort-desc": _vm.setSortDirection
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item",
                          fn: function(ref) {
                            var categoryItem = ref.item
                            return [
                              _c(
                                "td",
                                {
                                  staticClass: "category-cell",
                                  attrs: { colspan: _vm.headers.length }
                                },
                                [
                                  _c("v-data-table", {
                                    class: [
                                      "schedule-items",
                                      _vm.selectedJobTypeTab ===
                                        _vm.ALL_JOB_TYPES_ID ||
                                      _vm.jobTypes[_vm.selectedJobTypeTab]
                                        .length > 1
                                        ? "multiple"
                                        : "single"
                                    ],
                                    attrs: {
                                      dense: "",
                                      "fixed-header": "",
                                      "group-by": "jobTypeIndex",
                                      headers: _vm.headers,
                                      "hide-default-footer": "",
                                      "item-class": "type",
                                      items: categoryItem.activities,
                                      "items-per-page":
                                        categoryItem.activities.length,
                                      "mobile-breakpoint": "",
                                      "no-data-text": _vm.$t(
                                        "descriptions.noShifts"
                                      ),
                                      "show-expand": !_vm.compact,
                                      "single-select": ""
                                    },
                                    on: { "click:row": _vm.showItemDetails },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "group.header",
                                          fn: function(ref) {
                                            var jobTypeIndex = ref.group
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    colspan: _vm.headers.length
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "pl-1" },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.getJobLabel(
                                                              jobTypeIndex
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold job-count ml-2 px-1 inner-table"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              categoryItem.category ===
                                                                _vm
                                                                  .categoryMapping
                                                                  .onDuty
                                                                ? _vm.getJobCount(
                                                                    jobTypeIndex
                                                                  )
                                                                : _vm.getCategoryCount(
                                                                    categoryItem.category,
                                                                    jobTypeIndex
                                                                  )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  categoryItem.category ===
                                                  _vm.categoryMapping.onDuty
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold job-count ml-2 px-1 inner-table"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "labels.hours"
                                                                  ) +
                                                                    ": " +
                                                                    _vm.getJobHours(
                                                                      jobTypeIndex
                                                                    )
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.assigneeId",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _c(
                                                "v-list-item",
                                                { staticClass: "px-0" },
                                                [
                                                  !_vm.compact
                                                    ? _c(
                                                        "v-list-item-avatar",
                                                        { staticClass: "mr-1" },
                                                        [
                                                          _c(
                                                            "v-avatar",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  _vm.$store
                                                                    .state.org
                                                                    .employees[
                                                                    item.user
                                                                      .userId
                                                                  ]
                                                                    .avatarBgColor,
                                                                size: "30"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "white--text subtitle-2"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.getAvatar(
                                                                          _vm
                                                                            .$store
                                                                            .state
                                                                            .org
                                                                            .employees[
                                                                            item
                                                                              .user
                                                                              .userId
                                                                          ]
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "v-list-item-content",
                                                    {
                                                      class: _vm.compact
                                                        ? "py-1"
                                                        : ""
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          class: [
                                                            _vm.compact
                                                              ? "body-2 mb-0 name-n-avatar"
                                                              : "body-2 mb-1 name-n-avatar",
                                                            item.user.state ===
                                                            _vm.ACCOUNT_STATE
                                                              .active
                                                              ? ""
                                                              : "grey--text"
                                                          ],
                                                          attrs: {
                                                            title:
                                                              item.user.fullName
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-inline-block text-truncate",
                                                              style: {
                                                                width: _vm.compact
                                                                  ? "168px"
                                                                  : "134px"
                                                              }
                                                            },
                                                            [
                                                              _c("UserName", {
                                                                attrs: {
                                                                  user:
                                                                    _vm.$store
                                                                      .state.org
                                                                      .employees[
                                                                      item.user
                                                                        .userId
                                                                    ]
                                                                },
                                                                on: {
                                                                  saved:
                                                                    _vm.updateNurseDetails
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-list-item-subtitle",
                                                        {
                                                          class: [
                                                            _vm.compact
                                                              ? "caption mt-0 job-info"
                                                              : "caption mt-1",
                                                            item.user.state ===
                                                            _vm.ACCOUNT_STATE
                                                              .active
                                                              ? ""
                                                              : "grey--text"
                                                          ],
                                                          attrs: {
                                                            title: _vm.showFlagChips(
                                                              item
                                                            )
                                                              ? _vm.getJobAndFlagsText(
                                                                  item
                                                                )
                                                              : null
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.getJobInfo(
                                                                  item
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                          _vm.showFlagChips(
                                                            item
                                                          )
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "flag-chips ml-1"
                                                                },
                                                                _vm._l(
                                                                  _vm.getShiftFlags(
                                                                    item
                                                                  ),
                                                                  function(
                                                                    flag
                                                                  ) {
                                                                    return _c(
                                                                      "v-chip",
                                                                      {
                                                                        key:
                                                                          flag.id,
                                                                        staticClass:
                                                                          "lighten-2 grey--text text--darken-3 flag-short-code mr-1",
                                                                        attrs: {
                                                                          color:
                                                                            "info",
                                                                          "x-small":
                                                                            "",
                                                                          title:
                                                                            flag.name
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              flag.shortCode
                                                                            ) +
                                                                            "\n                          "
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        "nudge-left": "5",
                                                        right: ""
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var tooltipOn =
                                                                ref.on
                                                              var attrs =
                                                                ref.attrs
                                                              return [
                                                                _vm.openedPanelName ===
                                                                  "nurse-details" &&
                                                                _vm.panels[0] &&
                                                                _vm.panels[0]
                                                                  .userId ===
                                                                  item.user.id
                                                                  ? _c(
                                                                      "v-btn",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "info darken-1 staff-notes",
                                                                            attrs: {
                                                                              icon:
                                                                                "",
                                                                              "x-small":
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.preventDefault()
                                                                                $event.stopPropagation()
                                                                                return _vm.toggleNurseDetailsPanel(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          "v-btn",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        tooltipOn
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "white--text",
                                                                            attrs: {
                                                                              size:
                                                                                "10"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            fal fa-sliders-h fa-inverse\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : item.user
                                                                      .scheduleNotes
                                                                  ? _c(
                                                                      "v-btn",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "secondary lighten-4 staff-notes",
                                                                            attrs: {
                                                                              icon:
                                                                                "",
                                                                              "x-small":
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.preventDefault()
                                                                                $event.stopPropagation()
                                                                                return _vm.toggleNurseDetailsPanel(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          "v-btn",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        tooltipOn
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "anchor--text",
                                                                            attrs: {
                                                                              size:
                                                                                "10"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            fal fa-sliders-h\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _c(
                                                                      "v-btn",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "grey lighten-3 staff-notes",
                                                                            attrs: {
                                                                              icon:
                                                                                "",
                                                                              "x-small":
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.preventDefault()
                                                                                $event.stopPropagation()
                                                                                return _vm.toggleNurseDetailsPanel(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          "v-btn",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        tooltipOn
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "grey--text text--darken-3",
                                                                            attrs: {
                                                                              size:
                                                                                "10"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            fal fa-sliders-h\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "body-2"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "labels.viewStaffDetails"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm.getErrors(item.user)
                                                    .length > 0
                                                    ? _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            "nudge-left": "5",
                                                            right: "",
                                                            "max-width": "300px"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var tooltipOn =
                                                                    ref.on
                                                                  var attrs =
                                                                    ref.attrs
                                                                  return [
                                                                    _c(
                                                                      "v-icon",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "has-errors",
                                                                            attrs: {
                                                                              color:
                                                                                "error",
                                                                              "x-small":
                                                                                ""
                                                                            }
                                                                          },
                                                                          "v-icon",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        tooltipOn
                                                                      ),
                                                                      [
                                                                        _vm._v(
                                                                          "\n                          fal fa-exclamation-triangle\n                        "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "descriptions.staffErrors"
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.typeId",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              item.value &&
                                              item.type === "shift"
                                                ? _c(
                                                    "v-row",
                                                    {
                                                      class: [
                                                        "shift-type",
                                                        "pa-0",
                                                        item.value.overtime
                                                          ? "error--text"
                                                          : ""
                                                      ],
                                                      staticStyle: {
                                                        position: "relative"
                                                      },
                                                      attrs: {
                                                        align: "center",
                                                        justify: "center",
                                                        "no-gutters": ""
                                                      }
                                                    },
                                                    [
                                                      item.value
                                                        .departmentId !==
                                                        _vm.activeDepartment
                                                          .id ||
                                                      _vm.hasDefaultShiftTime(
                                                        item.value
                                                      )
                                                        ? [
                                                            item.value
                                                              .departmentId !==
                                                            _vm.activeDepartment
                                                              .id
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.getDepartmentByID(
                                                                          item
                                                                            .value
                                                                            .departmentId
                                                                        ).name
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ])
                                                              : [
                                                                  _c(
                                                                    "ScheduleSymbol",
                                                                    {
                                                                      attrs: {
                                                                        symbol: _vm.getSymbol(
                                                                          "shift",
                                                                          item
                                                                        ),
                                                                        entity:
                                                                          _vm
                                                                            .shiftTypes[
                                                                            item
                                                                              .value
                                                                              .typeId
                                                                          ]
                                                                      }
                                                                    }
                                                                  ),
                                                                  item.value
                                                                    .obligatory
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                          *\n                        "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                            item.category ===
                                                            _vm.categoryMapping
                                                              .nonDuty
                                                              ? _c("span", {
                                                                  staticClass:
                                                                    "non-duty"
                                                                })
                                                              : _vm._e()
                                                          ]
                                                        : [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "caption"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "d-block"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.getShiftTime(
                                                                            item.value
                                                                          )[0] +
                                                                            (item
                                                                              .value
                                                                              .obligatory
                                                                              ? "*"
                                                                              : "")
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "d-block"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.getShiftTime(
                                                                            item.value
                                                                          )[1]
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            item.category ===
                                                            _vm.categoryMapping
                                                              .nonDuty
                                                              ? _c("span", {
                                                                  staticClass:
                                                                    "non-duty custom-time"
                                                                })
                                                              : _vm._e()
                                                          ]
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              item.value &&
                                              item.type === "shift" &&
                                              _vm.wasShiftModifiedByManagement(
                                                item.value,
                                                _vm.$store.state
                                              )
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "management",
                                                      attrs: {
                                                        color: "nb-gold",
                                                        size: "10"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    fas fa-pencil\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              item.value &&
                                              item.type === "shift" &&
                                              _vm.hasDifferentPayrollDate(item)
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "payroll-diff text--darken-3",
                                                      attrs: {
                                                        color: "grey",
                                                        size: "10"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    fas fa-level-up\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              item.value && item.request
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "request",
                                                      attrs: {
                                                        color: "warning",
                                                        size: "10"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    fas fa-circle\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              item.value &&
                                              item.type === "event"
                                                ? _c(
                                                    "v-row",
                                                    {
                                                      staticStyle: {
                                                        height: "100%"
                                                      },
                                                      attrs: {
                                                        "align-content": "end",
                                                        "no-gutters": "",
                                                        title: _vm.getEventType(
                                                          item.value
                                                        ).name
                                                      }
                                                    },
                                                    [
                                                      _c("ScheduleSymbol", {
                                                        staticClass:
                                                          "ml-3 mb-1",
                                                        attrs: {
                                                          symbol: {
                                                            symbolType: "bar",
                                                            color: _vm.getEventType(
                                                              item.value
                                                            ).color,
                                                            style: {
                                                              height:
                                                                "5px !important",
                                                              width:
                                                                "32px !important"
                                                            }
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.flags",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              item.value &&
                                              item.type === "shift"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-truncate",
                                                      style: { width: "200px" }
                                                    },
                                                    _vm._l(
                                                      item.value.flags,
                                                      function(flagId) {
                                                        return _c(
                                                          "v-chip",
                                                          {
                                                            key: flagId,
                                                            staticClass:
                                                              "lighten-2 grey--text text--darken-3 flag-short-code mb-1 mr-1",
                                                            attrs: {
                                                              color: "info",
                                                              small: "",
                                                              title:
                                                                _vm
                                                                  .shiftFlagsById[
                                                                  flagId
                                                                ].name
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm
                                                                    .shiftFlagsById[
                                                                    flagId
                                                                  ].shortCode
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.comments",
                                          fn: function(ref) {
                                            var item = ref.item
                                            var header = ref.header
                                            return [
                                              item.value
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-inline-block text-truncate",
                                                      style: {
                                                        width:
                                                          header.width -
                                                          32 +
                                                          "px"
                                                      },
                                                      attrs: {
                                                        title:
                                                          item.value.comments
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            item.value.comments
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.lastFloat",
                                          fn: function(ref) {
                                            var item = ref.item
                                            var header = ref.header
                                            return [
                                              item.value &&
                                              _vm.lastFloat.users[
                                                item.value.assigneeId
                                              ] &&
                                              _vm.lastFloat.users[
                                                item.value.assigneeId
                                              ].last
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-inline-block text-truncate",
                                                      style: {
                                                        width:
                                                          header.width -
                                                          32 +
                                                          "px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm
                                                              .moment(
                                                                _vm.lastFloat
                                                                  .users[
                                                                  item.value
                                                                    .assigneeId
                                                                ].last
                                                                  .payrollDate ||
                                                                  _vm.lastFloat
                                                                    .users[
                                                                    item.value
                                                                      .assigneeId
                                                                  ].last.date
                                                              )
                                                              .format(
                                                                _vm.DATE_FORMAT_US
                                                              )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                : item.value &&
                                                  _vm.lastFloat.loading
                                                ? _c("v-progress-circular", {
                                                    attrs: {
                                                      color:
                                                        "primary lighten-2",
                                                      indeterminate: "",
                                                      size: "18",
                                                      width: "2"
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.lastCancel",
                                          fn: function(ref) {
                                            var item = ref.item
                                            var header = ref.header
                                            return [
                                              item.value &&
                                              _vm.lastCanceled.users[
                                                item.value.assigneeId
                                              ] &&
                                              _vm.lastCanceled.users[
                                                item.value.assigneeId
                                              ].last
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-inline-block text-truncate",
                                                      style: {
                                                        width:
                                                          header.width -
                                                          32 +
                                                          "px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm
                                                              .moment(
                                                                _vm.lastCanceled
                                                                  .users[
                                                                  item.value
                                                                    .assigneeId
                                                                ].last
                                                                  .payrollDate ||
                                                                  _vm
                                                                    .lastCanceled
                                                                    .users[
                                                                    item.value
                                                                      .assigneeId
                                                                  ].last.date
                                                              )
                                                              .format(
                                                                _vm.DATE_FORMAT_US
                                                              )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                : item.value &&
                                                  _vm.lastCanceled.loading
                                                ? _c("v-progress-circular", {
                                                    attrs: {
                                                      color:
                                                        "primary lighten-2",
                                                      indeterminate: "",
                                                      size: "18",
                                                      width: "2"
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.lastOvertime",
                                          fn: function(ref) {
                                            var item = ref.item
                                            var header = ref.header
                                            return [
                                              item.value &&
                                              _vm.lastOvertime.users[
                                                item.value.assigneeId
                                              ] &&
                                              _vm.lastOvertime.users[
                                                item.value.assigneeId
                                              ].last
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-inline-block text-truncate",
                                                      style: {
                                                        width:
                                                          header.width -
                                                          32 +
                                                          "px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm
                                                              .moment(
                                                                _vm.lastOvertime
                                                                  .users[
                                                                  item.value
                                                                    .assigneeId
                                                                ].last
                                                                  .payrollDate ||
                                                                  _vm
                                                                    .lastOvertime
                                                                    .users[
                                                                    item.value
                                                                      .assigneeId
                                                                  ].last.date
                                                              )
                                                              .format(
                                                                _vm.DATE_FORMAT_US
                                                              )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                : item.value &&
                                                  _vm.lastOvertime.loading
                                                ? _c("v-progress-circular", {
                                                    attrs: {
                                                      color:
                                                        "primary lighten-2",
                                                      indeterminate: "",
                                                      size: "18",
                                                      width: "2"
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "item.data-table-expand",
                                          fn: function(ref) {
                                            var expand = ref.expand
                                            var isExpanded = ref.isExpanded
                                            return [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    icon: "",
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      $event.preventDefault()
                                                      return expand(!isExpanded)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { small: "" } },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            isExpanded
                                                              ? "fas fa-chevron-up"
                                                              : "fas fa-chevron-down"
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "expanded-item",
                                          fn: function(ref) {
                                            var innerHeaders = ref.headers
                                            var item = ref.item
                                            return [
                                              item.value
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "px-0",
                                                      attrs: {
                                                        colspan:
                                                          innerHeaders.length
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-container",
                                                        {
                                                          staticClass:
                                                            "last-shift-browser mx-0 pr-0 py-0"
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "pa-0"
                                                                },
                                                                [
                                                                  _c(
                                                                    "LastShiftBrowser",
                                                                    {
                                                                      attrs: {
                                                                        user:
                                                                          item.user
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.selectedRows,
                                      callback: function($$v) {
                                        _vm.selectedRows = $$v
                                      },
                                      expression: "selectedRows"
                                    }
                                  }),
                                  _vm.readOnly
                                    ? _c("span", {
                                        staticClass: "read-only-overlay"
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: "group.header",
                          fn: function(ref) {
                            var group = ref.group
                            var isOpen = ref.isOpen
                            var toggle = ref.toggle
                            return [
                              _c(
                                "td",
                                {
                                  ref: group,
                                  class: isOpen ? "expanded" : "",
                                  attrs: { colspan: _vm.headers.length },
                                  on: {
                                    click: function($event) {
                                      return _vm.expandGroup(
                                        group,
                                        isOpen,
                                        toggle
                                      )
                                    }
                                  }
                                },
                                [
                                  isOpen
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticStyle: { width: "14px" },
                                          attrs: {
                                            color: "secondary",
                                            dense: "",
                                            size: "14"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                fas fa-caret-down\n              "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "v-icon",
                                        {
                                          staticStyle: { width: "14px" },
                                          attrs: {
                                            color: "secondary",
                                            dense: "",
                                            size: "14"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                fas fa-caret-right\n              "
                                          )
                                        ]
                                      ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "secondary--text pl-1 text-capitalize"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.getCategoryLabel(group)) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: "header.assigneeId",
                          fn: function() {
                            return [
                              !_vm.compact
                                ? _c("StaffSearch", {
                                    attrs: {
                                      "append-icon": _vm.staffFilter
                                        ? ""
                                        : "fal fa-search",
                                      "target-class": "daily-search-staff py-3",
                                      clearable: !!_vm.staffFilter,
                                      dense: "",
                                      "hide-details": "",
                                      solo: ""
                                    },
                                    model: {
                                      value: _vm.staffFilter,
                                      callback: function($$v) {
                                        _vm.staffFilter =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "staffFilter"
                                    }
                                  })
                                : _vm._e(),
                              _c(
                                "portal",
                                {
                                  attrs: {
                                    disabled: _vm.compact,
                                    to: "daily-schedule-actions"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "column-actions d-inline-block"
                                    },
                                    [
                                      _vm.$can("edit", "shift") ||
                                      _vm.$can("edit", "event")
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          "v-menu",
                                                          {
                                                            attrs: {
                                                              "min-width":
                                                                "150",
                                                              "offset-y": ""
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "activator",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var menuOn =
                                                                      ref.on
                                                                    return [
                                                                      _c(
                                                                        "v-btn",
                                                                        _vm._g(
                                                                          _vm._b(
                                                                            {
                                                                              class:
                                                                                _vm
                                                                                  .actionStyles
                                                                                  .addActivity
                                                                                  .button
                                                                                  .classes,
                                                                              attrs: {
                                                                                icon:
                                                                                  "",
                                                                                value:
                                                                                  "staff"
                                                                              }
                                                                            },
                                                                            "v-btn",
                                                                            attrs,
                                                                            false
                                                                          ),
                                                                          Object.assign(
                                                                            {},
                                                                            on,
                                                                            menuOn
                                                                          )
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              class:
                                                                                _vm
                                                                                  .actionStyles
                                                                                  .addActivity
                                                                                  .icon
                                                                                  .classes,
                                                                              attrs: {
                                                                                size:
                                                                                  "16"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            fal fa-plus\n                          "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          },
                                                          [
                                                            _c(
                                                              "v-list",
                                                              {
                                                                staticClass:
                                                                  "py-0",
                                                                attrs: {
                                                                  dense: ""
                                                                }
                                                              },
                                                              [
                                                                _vm.$can(
                                                                  "edit",
                                                                  "shift"
                                                                )
                                                                  ? _c(
                                                                      "v-list-item",
                                                                      {
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.preventDefault()
                                                                            return _vm.setPanelName(
                                                                              "addShift"
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            staticClass:
                                                                              "body-2 font-weight-regular"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            " +
                                                                                _vm._s(
                                                                                  _vm.$tc(
                                                                                    "labels.addShift",
                                                                                    1
                                                                                  )
                                                                                ) +
                                                                                "\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                _vm.$can(
                                                                  "edit",
                                                                  "event"
                                                                )
                                                                  ? _c(
                                                                      "v-list-item",
                                                                      {
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            $event.preventDefault()
                                                                            return _vm.setPanelName(
                                                                              "addEvent"
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            staticClass:
                                                                              "body-2 font-weight-regular"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            " +
                                                                                _vm._s(
                                                                                  _vm.$tc(
                                                                                    "labels.addEvent",
                                                                                    1
                                                                                  )
                                                                                ) +
                                                                                "\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                1059055896
                                              )
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "body-2" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "labels.addActivity"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "v-badge",
                                                    {
                                                      staticClass:
                                                        "badge-panel",
                                                      attrs: {
                                                        avatar: "",
                                                        color: "transparent",
                                                        overlap: ""
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "badge",
                                                            fn: function() {
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    class: [
                                                                      "status",
                                                                      _vm.hasCensusErrors
                                                                        ? ""
                                                                        : "no-errors"
                                                                    ],
                                                                    attrs: {
                                                                      color:
                                                                        "error",
                                                                      size: "12"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          fas fa-exclamation-triangle\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            },
                                                            proxy: true
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              class:
                                                                _vm.actionStyles
                                                                  .census.button
                                                                  .classes,
                                                              attrs: {
                                                                icon: "",
                                                                value: "census"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.setPanelName(
                                                                    "census"
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              class:
                                                                _vm.actionStyles
                                                                  .census.icon
                                                                  .classes,
                                                              attrs: {
                                                                size: "16"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          fal fa-cloud-upload-alt\n                        "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ])
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "body-2" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("labels.inputCensus")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          class:
                                                            _vm.actionStyles
                                                              .memos.button
                                                              .classes,
                                                          attrs: {
                                                            icon: "",
                                                            value: "memos"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.setPanelName(
                                                                "memos"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        "v-btn",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          class:
                                                            _vm.actionStyles
                                                              .memos.icon
                                                              .classes,
                                                          attrs: { size: "16" }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        fal fa-file-alt\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ])
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "body-2" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("labels.notes")
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }